import React, { FC } from 'react';
import { Path } from './styles';

const Heart: FC<SVGIconProps> = ({ color }) => (
  <svg width="63" height="63" viewBox="0 0 63 63" fill="none">
    <Path
      d="M31.5 56.0438L27.6938 52.5788C14.175 40.32 5.25 32.2087 5.25 22.3125C5.25 14.2013 11.6025 7.875 19.6875 7.875C24.255 7.875 28.6387 10.0012 31.5 13.335C34.3613 10.0012 38.745 7.875 43.3125 7.875C51.3975 7.875 57.75 14.2013 57.75 22.3125C57.75 32.2087 48.825 40.32 35.3062 52.5788L31.5 56.0438Z"
      fillColor={color}
    />
  </svg>
);

export default Heart;
